import { render, staticRenderFns } from "./TenderFinished.vue?vue&type=template&id=12b5e650"
import script from "./TenderFinished.vue?vue&type=script&lang=js"
export * from "./TenderFinished.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports